import { AxiosResponse } from "axios";
import { IApiResponse } from "../../../@types/api-response.type";
import { Api } from "../ApiConfig"
import { ApiException } from "../ApiException"
import { ICostCenter } from "../../../@types/costCenter.type";
import { IReportMetricsBody } from "../../../@types/reports-metrics.type";
import { IKeyValue } from "../../../@types/key-value.type";
import { downloadExcel } from "../../../utils/download";
import { getErrorMessage } from "../../../utils/utils";

export const getAllCostCenters = async (): Promise<IApiResponse<ICostCenter[]> | ApiException> => {

  try {
    const { data } = await Api.get<IApiResponse<ICostCenter[]>>(`/api/CostCenter/GetAllCostCenters`)
    return data

  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Centros de custos'))
  }
}


export const getCostCenterById = async (id: string): Promise<IApiResponse<ICostCenter> | ApiException> => {

  try {
    const { data } = await Api.get<IApiResponse<ICostCenter>>(`/api/CostCenter/GetCostCenterById?id=${id}`)
    return data

  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar o Centro de custo'))
  }
}


export const addOrUpdateCostCenter = async (customCenter: ICostCenter): Promise<void> => {
  try {
    await Api.post<AxiosResponse<void>>('/api/CostCenter/AddOrUpdateCostCenter', customCenter);
  } catch (error) {
    const message = 'Erro ao criar ou atualizar Centro de Custo';
    throw new ApiException(getErrorMessage(error, message));
  }
}

export const deleteCostCenter = async (id: string) => {

  try {
    await Api.delete(`/api/CostCenter/DeleteCostCenter/${id}`);
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao deletar o Centro de Custo'))
  }
}

export const getCostCenterMetrics = async (costCenter: IReportMetricsBody) => {
  try {
    const { data } = await Api.post("/api/CostCenter/GetCostCenterMetrics",
      {
        "id": costCenter.id, "startTime": costCenter.startTime,
        "endTime": costCenter.endTime, "timeType": costCenter.timeType
      });
    return data;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao consultar metricas do Centro de Custo'))
  }
}

export const getAllCostCentersIdsAndNames = async (): Promise<IKeyValue[]> => {
  try {
    const { data } = await Api.get<IApiResponse<IKeyValue[]>>("/api/CostCenter/GetAllCostCentersIdsAndNames");
    return data.result;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao consultar ids e nomes do Centro de Custo'))
  }
}

export const downloadCostCentersReportToExcel = async (filters: IReportMetricsBody): Promise<void> => {
  try {
    const response = await Api.post("/api/CostCenter/DownloadCostCentersReportToExcel",
      filters  , { responseType: "blob" });

    downloadExcel("Relatorio-Centro-Custo", response.data);
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao fazer download do relatório de Centro de Custo'))
  }
}
